<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Environmental Law
    </Heading>

    <p>
      Environmental issues have a central place in the public consciousness, the
      media and state, local and national politics. Real and perceived
      environmental threats from such diverse sources as landfills, factories,
      real estate developments, farms, energy generators and consumer products
      have produced laws and regulations at all levels of government and a
      proliferation of litigation over environmental liabilities. Moreover,
      since most environmental statutes now contain criminal sanctions, persons
      can be subject to criminal prosecution not only for contributing to
      pollution, but for failing to report pollution. Accordingly, our firm’s
      practice of environmental law encompasses an understanding of multiple
      sub-specialties, as well as skills in sophisticated litigation techniques,
      technical aspects of environmental sciences, corporate legal issues and
      criminal law and procedure. Consequently, attorneys with a keen, unbiased
      eye are required. Hobson Bernardino + Davis has those attorneys.
    </p>
    <p>
      Our firm’s environmental practice is as broad and as deep as almost any
      environmental practice at any law firm in the United States. We represent
      corporations, developers and energy companies in cutting-edge
      environmental litigation and in solving complex regulatory and
      transactional issues. The firm regularly counsels clients on the
      environmental aspects of commercial and real estate transactions, provides
      regulatory advice and litigates matters under CERCLA and other
      environmental statutes. The attorneys of Hobson Bernardino + Davis
      practice, speak and write extensively on environmental issues. Among the
      types of environmental transactions engaged in by our attorneys are the
      following: negotiating and drafting tolling agreements, remediation
      agreements, licensing agreements, leases, lease amendments, indemnity
      agreements and access agreements; participating in development and
      financing/re-financing issues; responding to requests for information from
      governmental agencies and private parties; reviewing and analyzing claims
      from third parties affected by energy development or distribution;
      analyzing insurance issues and tender claims where applicable, and;
      interfacing with local, state and federal regulatory agencies. For ARCO
      alone, the firm’s attorneys have handled over one hundred transactions
      impacted by environmental concerns, ranging from purchase and sale of
      property to loan agreements. None of these transactional matters ever
      resulted in litigation, nor was ARCO ever fined or subject to any private
      or regulatory penalty.
    </p>
    <p>
      The firm’s attorneys have a wealth of experience in federal and state
      enforcement cases (both civil and criminal), permitting and other
      administrative proceedings. For example, the firm’s attorneys have acted
      as lead defense counsel in a considerable amount of nationwide product
      liability litigation concerning allegedly hazardous materials.
      Environmental litigation has long been a hallmark of the firm’s attorneys
      and a prominent aspect of the firm’s environmental practice. Examples of
      recent environmental cases litigated by our attorneys include: ARCO adv.
      Douglass, Santa Barbara County Superior Court, defense verdict following
      54 day jury trial on environmental torts; ARCO adv. Mitchell Land &
      Improvement Company, Riverside County Superior Court, nonsuit in favor of
      ARCO on disposal dispute; Koch Industries adv. Harms, Nueces County
      District Court, Texas, successful defense of environmental class action
      lawsuit resulting in de minimis settlement by Koch Industries; Koch
      Industries adv. OCI Superfund Site, United States District Court, W. D.
      Michigan, successful defense of “superfund” lawsuit resulting in de
      minimis settlement, and; In re OCI, United States District Court, Central
      District of California, successful defense of “superfund” lawsuit
      resulting in dismissal.
    </p>
    <p>
      In sum, over the past twenty years, the firm’s attorneys have represented
      clients in all aspects of environmental law. The following is a brief
      synopsis of our attorneys’ environmental law experience:
    </p>
    <ol>
      <li>
        Cost recovery litigation on behalf of both plaintiffs and defendants;
      </li>
      <li>
        Hazardous waste cleanup compliance and counseling under CERCLA, RCRA,
        HSAA, Porter-Cologne and Polanco Redevelopment Act;
      </li>
      <li>
        Litigation and counseling under the Federal Clean Water Act, Endangered
        Species Act, National Environmental Policy Act, Federal Power Act and
        California Environmental Quality Act;
      </li>
      <li>
        Preparing, defending and challenging Environmental Impact Reports (EIR)
        and Environmental Impact Statements (EIS);
      </li>
      <li>Underground storage tank litigation;</li>
      <li>
        Litigation under the Federal Tort Claims Act and Fifth Amendment takings
        law;
      </li>
      <li>Defense of Proposition 65 claims;</li>
      <li>Defense of Business & Professions Code Section 17200 claims;</li>
      <li>Insurance coverage of environmental cleanups;</li>
      <li>Project permitting and transfer issues;</li>
      <li>
        Assisting clients in preparing their Hazardous Materials Business Plan,
        Risk Management and Prevention Program, and other materials, in addition
        to developing an overall environmental compliance schedule;
      </li>
      <li>
        Landfill projects, oily soil projects and similar projects under the
        supervision of Cal-EPA’s Department of Toxic Substances Control;
      </li>
      <li>
        Advising clients on environmental requirements in storage tank removal
        and hazardous waste transportation;
      </li>
      <li>
        Drafting and negotiating agreements for various matters such as removal,
        hazardous waste disposal and property access;
      </li>
      <li>
        Assisting numerous companies, small, medium and large, with compliance
        requirements of Proposition 65;
      </li>
      <li>Developing and conducting environmental audit programs;</li>
      <li>Toxic tort litigation;</li>
      <li>
        Developing procedures for emergency response to oils spills and
        participating in the emergency spill response;
      </li>
      <li>
        Representing clients before the California Regional Water Quality
        Control Boards;
      </li>
      <li>
        Representing underground storage tank owners before county and local
        agencies;
      </li>
      <li>
        Counseling banking clients concerning contaminated property held as
        security and foreclosure, and counseling clients negotiating with banks
        and other lenders regarding environmental matters and due diligence;
      </li>
      <li>
        Conducting environmental due diligence and drafting disclosure
        statements for SEC documents;
      </li>
      <li>
        Conducting environmental due diligence for purposes of obtaining private
        financing;
      </li>
      <li>Drafting and negotiating indemnity agreements;</li>
      <li>Drafting and negotiating access agreements;</li>
      <li>Drafting and negotiating remediation agreements;</li>
      <li>Drafting and negotiating tolling agreements;</li>
      <li>
        Drafting and negotiating “comfort” letters for use by borrowers and
        lenders;
      </li>
      <li>
        Advising purchasers, sellers and lenders regarding the allocation and
        management of environmental risks in real property transactions;
      </li>
      <li>
        Advising clients regarding sale of property with groundwater
        contamination;
      </li>
      <li>
        Advising clients regarding sales of property with groundwater
        contamination migrating to or from neighboring property;
      </li>
      <li>
        Advising clients regarding acquisition and sale of shopping centers with
        environmental issues relating to underground gasoline storage tanks;
      </li>
      <li>
        Advising clients, including issuers, equity participants, and
        underwriters, in connection with corporate financing transactions and
        environmental diligence and disclosure pursuant to SEC requirements
        across a variety of industries, including petroleum, chemical,
        manufacturing, and electronics;
      </li>
      <li>
        Representing clients in criminal proceedings before state and federal
        courts;
      </li>
      <li>
        Counseling clients targeted by Grand Jury Investigation in various parts
        of the United States concerning alleged environmental violations;
      </li>
      <li>
        Counseling clients and representing them in administrative proceedings
        with local fire and county health departments concerning the monitoring,
        upgrade and corrective action for underground storage tanks;
      </li>
      <li>
        Defending against criminal actions alleging violations of air pollution
        control laws, illegal disposal of hazardous waste, and violation of
        occupational safety and health standards;
      </li>
      <li>
        Pipeline litigation, including defense of class action litigation by
        fisherman, homeowners, and others arising out of pipeline spills;
      </li>
      <li>
        Obtaining approval of numerous refinery and other oil industry projects
        from local and state environmental agencies;
      </li>
      <li>
        Prosecuting and defending numerous private cost recovery actions by
        current and former property owners and tenants asserting claims for
        damage, and soil and groundwater contamination resulting from discharges
        of oil, petroleum products, and chemicals;
      </li>
      <li>
        Prosecuting and defending lawsuits arising from leaking underground
        storage tanks;
      </li>
      <li>
        Prosecuting claims against the California Underground Storage Tank Fund
        (the firm has previously recovered funds for our clients);
      </li>
      <li>
        Representing potentially responsible parties at Superfund sites
        nationwide;
      </li>
      <li>
        Prosecuting first-party and third-party claims against carriers under
        CGL policies for coverage for environmental losses (the firm does not
        represent any insurance company, and there has never been a conflict
        regarding such actions);
      </li>
      <li>
        Defending against allegations arising from a major oil spill (the firm
        routinely represents a major oil company in an actions brought by the
        United States and the State of California); and
      </li>
      <li>
        Advising clients in connection with environmental legislation, including
        the drafting of legislative positions.
      </li>
    </ol>
    <p>
      The firm’s overriding philosophy is to provide our clients with
      cost-effective representation to navigate the sometimes complex system of
      state and federal regulations, to adequately assess the risks of a given
      situation, to minimize legal exposure for past practices and to maximize
      clients’ recovery against others who are responsible. Name partner, Rafael
      Bernardino, has unique experience representing several Fortune 500
      companies in environmental law matters and has often defended and
      prosecuted CERCLA and RCRA lawsuits on behalf of small, medium and large
      businesses. This area of the firm’s practice involves representation of
      clients in negotiations, litigation and settlements on clean-up
      enforcement orders issued by state and federal environmental authorities
      and in cost recovery actions.
    </p>
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewEnvironmentalLaw" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
